const navLinks = [
    {
        path : "/#home",
        name : 'home',
    },
    {
        path : '/#about',
        name : 'about',
    },
    {
        path : '/#skills',
        name : 'skills',
    },
    {
        path : '/#experience',
        name : 'experience',
    },
    {
        path : '/#projects',
        name : 'projects',
    },
    {
        path : '/#socialmedia',
        name : 'Social Media',
    },
    {
        path : '/#contact',
        name : 'contact',
    },
]

export default navLinks;